












import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import {Icon} from "@/helpers/icons";
import AsiCardDetail from "@/components/common/AsiCardDetail.vue";
import AsiCardDetailEntry from "@/components/common/AsiCardDetailEntry.vue";
import Report from "@/models/report/Report";
import ReportUpdateDialogAdditionalInfosDriver
	from "@/components/report/ReportUpdateDialogAdditionalInfosDriver.vue";
import {Permissions, ReportState} from "@/helpers/constants";

@Component({
	components: {
		ReportUpdateDialogAdditionalInfosDriver,
	    AsiCardDetailEntry,
		AsiCardDetail
	}
})
export default class ReportCardAdditionalInfosDriver extends Vue {

	@Prop({type: Object, default: null})
	public report!: Report | null;

	private icons = Icon;
	private updateDialogOpen: boolean = false;

	private get canBeEdited(): boolean {
		if (this.report === null) return false;

		if (this.report.state === ReportState.created) {
			return this.isDriverOfReport || this.isOffice;
		} else if (this.report.state !== ReportState.locked) {
			return this.isCheckReports || this.isBilling;
		} else {
			return false;
		}
	}

	private get isDriverOfReport(): boolean {
		if (this.report === null) return false;
		return this.report.user.id === this.$store.getters['user/userId'];
	}

	private get isInternal(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightInternal);
	}

	private get isOffice(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightOffice);
	}

	private get isCheckReports(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightCheckReports);
	}

	private get isBilling(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightBilling);
	}

	@Emit('reportChanged')
	public reportChanged(event: Event): Event {
		this.updateDialogOpen = false;
		return event;
	}

}
